import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faUserAlt } from '@fortawesome/pro-solid-svg-icons/faUserAlt';
import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.css';

export const ActivityItem = ({ time, message, userName }) => {
  return (
    <div className={style['product-activity']}>
      <div className={style['activity-container']}>
        <div className={style['activity-left']}>
          <div className={style['activity-time']}>
            <FontAwesomeIcon className={style['activity-icon']} icon={faClock} />
            {time}
          </div>
          <div className={style['activity-message']}>{message}</div>
        </div>
        <div className={style['activity-user']}>
          <FontAwesomeIcon className={style['activity-icon']} icon={faUserAlt} />
          {userName}
        </div>
      </div>
    </div>
  );
};

ActivityItem.propTypes = {
  time: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  userName: PropTypes.string.isRequired,
};
